if ('serviceWorker' in navigator) {
  const baseUrl =
    typeof import.meta !== 'undefined' ? import.meta.env.BASE_URL : '/';
  const swPath = `${baseUrl}service-worker.js`;

  const scope = import.meta.env.BASE_URL || '/';

  window.addEventListener('load', () => {
    console.log('Page loaded, attempting to register Service Worker...');
    console.log(`Service Worker Path: ${swPath}`);
    console.log(`Service Worker Scope: ${scope}`);

    navigator.serviceWorker
      .register(swPath, { scope })
      .then(registration => {
        console.log(
          `Service Worker registered successfully with scope: ${registration.scope}`
        );
      })
      .catch((error: unknown) => {
        // Service worker registration is a progressive enhancement — the app works
        // fine without it. Registration is routinely rejected by crawler/bot runtimes
        // and unsupported browsers, so warn (not console.error, which RUM captures as
        // an error) to keep these non-actionable failures out of Error Tracking.
        console.warn('Service Worker registration failed:', error);
      });
  });
}
export {};
